export default "__VITE_ASSET__7158d71b__"